import React, { useState, useContext, useEffect, useRef } from "react";
import { ContextApp, get_userhistory } from "../utils/Context";
import "./Chat.css";
import axios from "axios";
import CustomizedTables from "../utils/CustomizedTables";
import {
  Button,
  Modal,
  Box,
  Typography,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  Divider,
  FormHelperText
} from "@mui/material"; // Importing Material-UI Button
import robotIcon from "../pics/robot5.png";
import { FcBusinessman, FcCdLogo } from "react-icons/fc"; // Businessman icon for bot
import { Avatar } from "@mui/material"; // Importing Material-UI Avatar
import { API } from "./MyApi";
import * as XLSX from "xlsx";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile"; // Icon for file
import { Snackbar, Alert } from "@mui/material";
import Plot from "react-plotly.js";
import MarkdownFormat from "../utils/MarkdownFormat";
import { styled } from "@mui/material/styles";
import JSZip from "jszip";
import CloseIcon from '@mui/icons-material/Close';
import { FormControlLabel } from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  borderRadius: "18px",
  p: 4,
};

// Styled Dialog component for custom appearance
const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "12px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
    padding: theme.spacing(2),
    backgroundColor: "#f9f9f9",
    width: "550px",
  },
  "& .MuiDialogTitle-root": {
    // color: '#3f51b5',
    fontWeight: "bold",
    fontSize: "1rem",
  },
  "& .MuiDialogContentText-root": {
    color: "#333",
    fontSize: "1rem",
    marginBottom: theme.spacing(2),
  },
}));

const CustomButton = styled(Button)({
  color: "#ffffff",
  backgroundColor: "#111827", // Dark slate color
  "&:hover": {
    backgroundColor: "#1f2937", // Slightly lighter shade for hover effect
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function Chat() {
  const {
    setLoaderOpen,
    sheetName,
    setSheetName,
    message,
    email,
    setMessage,
    reset_newchat,
    msgEnd,
    selectedFile,
    setSelectedFile,
    user,
    get_userhistory,
    getBaseFilename,
    userHistory,
    showDeleteDialog,
    setShowDeleteDialog,
    shortFileName,
    setShortFileName,
    handleDeleteClick,
    openFilenameModal,
    setOpenFilenameModal,
    isClassificationRequired,
    setIsClassificationRequired,
    set_setuuid,
    uuid
  } = useContext(ContextApp);

  const fileInputRef = useRef(null);
  const [availableSheets, setAvailableSheets] = useState([]);
  const [isExcelFile, setIsExcelFile] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [fileobj, setFileobj] = useState("");
  const [snackopen, setSnackopen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState("");
  // const [openFilenameModal, setOpenFilenameModal] = useState(false);
  const [customFilename, setCustomFilename] = useState("");
  const [openFileseModal, setOpenFilesModal] = useState(false);
  const [fileSheets, setFileSheets] = useState([]);
  const [selectedSheetnames, setSelectedSheetnames] = useState([]);
  const [fileSheetSelections, setFileSheetSelections] = useState({});
  const [inputFieldError, setInputFieldError] = useState(false);
  const [inputFieldHelperText, setInputFieldHelperText] = useState("");
  const intervalRef = useRef(null);
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);
  // console.log('fileSheetSelections', fileSheetSelections);
  // console.log('files :>> ', files);
  // console.log('selectedSheetnames :>> ', selectedSheetnames);
  // console.log('customFilename :>> ', customFilename);

  // const [classificationResults, setClassificationResults] = useState({});
  

  useEffect(() => {
    const chatContainer = document.querySelector(".chat-container");
    // //Limit the chat code
    // if (message.length > 10) {
    //   const preservedMessages = message.slice(0, 2);
    //   const latestMessages = message.slice(-10);
    //   const updatedMessages = [...preservedMessages, ...latestMessages.slice(preservedMessages.length)];
    //   setMessage(updatedMessages);
    // }
    if (chatContainer) {
      chatContainer.scrollTop += 3000;
    }
  }, [message]);

  useEffect(() => {
    const validNameRegex = /^[a-zA-Z][a-zA-Z0-9\s]*$/;
    if (customFilename.length === 0) {
      setInputFieldError(false);
      setInputFieldHelperText("");
    } else if (!validNameRegex.test(customFilename)) {
      setInputFieldError(true);
      setInputFieldHelperText("Special characters are not allowed");
    } else {
      setInputFieldError(false);
      setInputFieldHelperText("");
    }
  }, [customFilename]);

  const handleCloseModal = () => setOpenModal(false);
  const handleCloseDialog = () => setOpenDialog(false);
  const handleFileDialog = () => {
    setSelectedFiles([]);
    setFileSheetSelections({});
    setSelectedSheetnames([]);
    setFiles([]);
    setFileSheets([]);
    setCustomFilename("");
    setOpenFilesModal(false);
  };

  const getStatus = async (email, customFilename) => {
    const status_resp = await API.postData("/getJobStatus", {
      "userEmail": email,
      "jobName": customFilename,
    });
    return status_resp;
  };

  // const handleSelectedSheetChange = (event) => {
  //   const {
  //     target: { value },
  //   } = event;

  //   const sheets = typeof value === "string" ? value.split(",") : value;

  //   // Store selected sheets for the current file
  //   setFileSheetSelections((prev) => ({
  //     ...prev,
  //     [selectedFiles]: sheets,
  //   }));

  //   // Also update selected sheet names for UI
  //   setSelectedSheetnames(sheets);
  // };

  const handleSelectedSheetChange = (event) => {
    const {
      target: { value },
    } = event;

    let sheets = typeof value === "string" ? value.split(",") : value;

    // Handle Select All logic
    if (sheets.includes("all")) {
      if (selectedSheetnames.length === fileSheets.length) {
        sheets = []; // Unselect all
      } else {
        sheets = [...fileSheets]; // Select all
      }
    }

    // Update state
    setFileSheetSelections((prev) => ({
      ...prev,
      [selectedFiles]: sheets,
    }));

    setSelectedSheetnames(sheets);
  };

  const isUploadDisabled = (fileSheetSelections, files) => {
    const hasSelectedSheets = Object.values(fileSheetSelections).some(
      (arr) => Array.isArray(arr) && arr.length > 0
    );

    const hasCsvOrParquetFiles = files.some((file) => {
      const ext = file.name.toLowerCase();
      return ext.endsWith(".csv") || ext.endsWith(".parquet");
    });

    return hasSelectedSheets || hasCsvOrParquetFiles;
  };

  const filterSheetsFromFiles = async (files) => {
    console.log('aaaaaaaaa', files)
    setOpenFilesModal(false);
    setLoaderOpen(true);

    await API.postData("/updateMetaJson", {
      userEmail: email,
      status: "INPROGRESS",
      fileName: customFilename,
    });

    get_userhistory();
    setLoaderOpen(false);
    try {
      // const updatedFiles = await Promise.all(
      //   files.map(async (file) => {
      //     const fileName = file.name.toLowerCase();
      //     const isCSV = fileName.endsWith(".csv");
      //     const isParquet = fileName.endsWith(".parquet");
      //     const isExcel =
      //       fileName.endsWith(".xlsx") || fileName.endsWith(".xls");

      //     if (isCSV || isParquet) {
      //       return file;
      //     }

      //     if (isExcel && fileSheetSelections[file.name]) {
      //       const data = await file.arrayBuffer();
      //       const workbook = XLSX.read(data, { type: "array" });

      //       const allowedSheets = fileSheetSelections[file.name];
      //       const newWorkbook = XLSX.utils.book_new();

      //       allowedSheets.forEach((sheetName) => {
      //         const sheet = workbook.Sheets[sheetName];
      //         sheet &&
      //           XLSX.utils.book_append_sheet(newWorkbook, sheet, sheetName);
      //       });

      //       const wbout = XLSX.write(newWorkbook, {
      //         bookType: "xlsx",
      //         type: "array",
      //       });
      //       return new File([wbout], file.name, { type: file.type });
      //     }

      //     // Skip unsupported files
      //     return null;
      //   })
      // );

      // Filter out any null entries (e.g. unsupported files)
      // const validFiles = files.filter(Boolean);
      createZipFile(files);
    } catch (error) {
      console.error("Error filtering sheets:", error);
      setSelectedFiles([]);
      setFileSheetSelections({});
      setSelectedSheetnames([]);
      setFiles([]);
      setFileSheets([]);
      setOpenFilesModal(false);
      setCustomFilename("");
      setShowCloseConfirm(false);
    } finally {
      setLoaderOpen(false);
    }
  };

  const handleUploadedFileChange = (event) => {
    setLoaderOpen(true);
    const fileName = event.target.value;
    setSelectedFiles(fileName);

    const selectedFileObj = files.find((file) => file.name === fileName);

    if (selectedFileObj) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetNames = workbook.SheetNames;

        setFileSheets(sheetNames);

        // Restore previously selected sheets if they exist
        const previouslySelectedSheets = fileSheetSelections[fileName] || [];
        setSelectedSheetnames(previouslySelectedSheets);

        setLoaderOpen(false);
      };
      reader.readAsArrayBuffer(selectedFileObj);
    }
  };

  // const handleFileChange = async (event) => {
  //   console.log("im also here");
  //   if (!event.target.files || !event.target.files[0]) {
  //     reset_newchat();
  //   } else {
  //     setFileobj(event.target.files[0]);
  //     const file = event.target.files[0];
  //     console.log("im in selected file state", event.target.files[0]);

  //     if (file.name.includes(".xls")) {
  //       setSnackopen(true);
  //       setTimeout(async () => {
  //         setIsExcelFile(true);
  //         try {
  //           const data = await file.arrayBuffer();
  //           const workbook = XLSX.read(data, { type: "array" });

  //           const sheets = workbook.SheetNames;
  //           if (sheets.length === 1) {
  //             setOpenModal(false);
  //             handleUpload(file);
  //           } else {
  //             setOpenModal(true);
  //           }
  //           setAvailableSheets(sheets);
  //           setSheetName(sheets[0]);
  //         } catch (error) {
  //           console.error("Error reading the Excel file:", error);
  //           alert("Failed to read the Excel file. Please try again.");
  //         }
  //       }, 0);
  //     } else {
  //       handleUpload(file);
  //     }
  //   }
  // };

  const handleFileChange = async (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      reset_newchat();
      return;
    }

    const files = Array.from(event.target.files);
    if (files.length > 3) {
      setDialogMessage("Only 3 files can be selected");
      setOpenDialog(true);
      return;
    }

    const nonExcelFiles = files.filter(
      ({ name }) =>
        !["xlsx", "xls", "csv", "parquet"].includes(
          name.split(".").pop().toLowerCase()
        )
    );

    if (nonExcelFiles.length > 0) {
      setDialogMessage(
        "Only Excel, csv and parquet files are allowed. Please select a valid file."
      );
      setOpenDialog(true);
      return;
    }

    const oversizedFiles = files.filter(
      (file) => file.size > 150 * 1024 * 1024
    );
    if (oversizedFiles.length > 0) {
      setDialogMessage("Please upload files smaller than 100 MB.");
      setOpenDialog(true);
      return;
    }

    const onlyCsvOrParquet = files.every((file) => {
      const ext = file.name.split('.').pop().toLowerCase();
      return ['csv', 'parquet'].includes(ext);
    });

    // const onlyExcelWithOneSheet = await Promise.all(
    //   files.map(async (file) => {
    //     const ext = file.name.split('.').pop().toLowerCase();
    //     if (ext === 'xlsx' || ext === 'xls') {
    //       const data = await file.arrayBuffer();
    //       const workbook = XLSX.read(data, { type: 'array' });
    //       return workbook.SheetNames.length === 1;
    //     }
    //     return false;
    //   })
    // ).then(results => results.every(Boolean));

    if (onlyCsvOrParquet) {
      setFiles(files);
      setOpenFilenameModal(false);
      setCustomFilename("")
      setTimeout(async () => {
        await filterSheetsFromFiles(files)
      }, 500);
    }
    // else if(onlyExcelWithOneSheet) {
    //   console.log('esle ifffffffffffffff')

    //   setFiles(files);
    //   setOpenFilenameModal(false);
    //   setCustomFilename("")
    //   setTimeout(async () => {
    //     await filterSheetsFromFiles(files)
    //   }, 500);
    // }

    // Store selected files and show the filename modal
    else {

      setFiles(files);
      const newSelections = files.reduce((acc, file) => {
        const ext = file.name.split('.').pop().toLowerCase();
        if (ext !== 'csv' && ext !== 'parquet') {
          acc[file.name] = [];
        }
        return acc;
      }, {});

      setFileSheetSelections((prev) => ({
        ...prev,
        ...newSelections,
      }));
      setOpenFilenameModal(false);
      setOpenFilesModal(true);
    }
  };

  // const handleSubmit = (event) => {
  //   if (sheetName) {
  //     console.log(`File: ${fileobj.name}, Sheet Name: ${sheetName}`);
  //     handleUpload(fileobj);
  //   } else {
  //     alert("Please select a valid sheet name.");
  //     reset_newchat();
  //   }
  //   setOpenModal(false); // Close modal after submission
  // };

  const handleSheetChange = (event) => {
    setSheetName(event.target.value);
  };

  // const handleUpload = async (file) => {
  //   if (true) {
  //     setLoaderOpen(true);
  //     let fileName = ''
  //     try {
  //       const myfilename = file.name;
  //       const presignedResponse = await API.postData(
  //         "/pre_signed_url_for_file",
  //         { file_name_: myfilename }
  //       );
  //       const { fields, url, actual_filename } = presignedResponse;
  //       get_userhistory();
  //       fileName = actual_filename.split('.').slice(0, -1).join('.')

  //       console.log("Pre-signed URL fields:", fields);
  //       console.log("Pre-signed URL:", url);
  //       console.log("Actual filename:", actual_filename);

  //       const formData = new FormData();
  //       for (const [key, value] of Object.entries(fields)) {
  //         formData.append(key, value);
  //       }
  //       formData.append("file", file);

  //       for (let pair of formData.entries()) {
  //         console.log(pair[0] + ": " + pair[1]);
  //       }

  //       const uploadResponse = await axios.post(url, formData, {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //           Accept: "*/*",
  //         },
  //       });
  //       console.log("Upload response:", uploadResponse);
  //       if (uploadResponse.status === 204 || uploadResponse.status === 200) {
  //         setLoaderOpen(false);
  //         // get_userhistory();
  //         console.log("File uploaded successfully to S3");
  //       }

  //       const resp = await API.postData("/upload_file_to_s3", {
  //         useremail: email,
  //         uploaded_file_name: actual_filename,
  //         sheet_name: sheetName,
  //       });
  //       if (resp?.message) {
  //         await API.postData("/updateMetaJson", {
  //           userEmail: email,
  //           status: "READY",
  //           fileName: fileName,
  //         });
  //         get_userhistory();
  //       }
  //       console.log("File uploaded resp:", resp);
  //       // get_userhistory();
  //       setMessage([
  //         {
  //           text: "Hello **" + user + "**, Let's start using **Ainsights Bot**",
  //           isBot: true,
  //           uploadbutton: true,
  //         },
  //         {
  //           text:
  //             "Currently working on - **File :: " +
  //             getBaseFilename(resp.filekey) +
  //             "**" +
  //             resp.sheetname,
  //           isBot: true,
  //         },
  //       ]);
  //       setSelectedFile(resp.filekey);
  //     } catch (error) {
  //       await API.postData("/updateMetaJson", {
  //         userEmail: email,
  //         status: "FAILED",
  //         fileName: fileName,
  //       });
  //       console.error("Error uploading file:", error);
  //       // alert("Failed to upload file.");
  //       get_userhistory();
  //       setLoaderOpen(false);
  //     } finally {
  //       // setLoaderOpen(false);
  //     }
  //   }
  // };

  const handleFilenameSubmit = async () => {
    if (!customFilename.trim()) {
      setDialogMessage("Filename is required.");
      setOpenDialog(true);
      return;
    }

    const usedNames = userHistory.map(
      (historyObj) => Object.keys(historyObj)[0]
    );
    if (usedNames.includes(customFilename.trim())) {
      // setDialogMessage("Job name should be unique.");
      // setOpenDialog(true);

      setInputFieldError(true);
      setInputFieldHelperText("Job name must be unique");
    } else {
      setCustomFilename(customFilename.trim());
      setSelectedSheetnames([]);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
        fileInputRef.current.click();
      }

      // setOpenFilenameModal(false);
      // setOpenFilesModal(true);
    }
    // createZipFile(selectedFiles, customFilename);
  };

  const createZipFile = async (files) => {
    const zip = new JSZip();
    files.forEach((file) => zip.file(file.name, file));
    console.log("customFilename", customFilename);

    try {
      const zipBlob = await zip.generateAsync({ type: "blob" });
      const zipFileName = `${customFilename}.zip`;
      const zipFile = new File([zipBlob], zipFileName, {
        type: "application/zip",
      });

      const presignedResponse = await API.postData("/pre_signed_url_for_zip", {
        "useremail": email,
        "jobname": customFilename,
      });
      const { fields, url } = presignedResponse;

      console.log("presignedResponse response:", presignedResponse);
      if (presignedResponse) {
        setCustomFilename("");
        get_userhistory();
      }
      const formData = new FormData();
      Object.entries(fields).forEach(([key, value]) => {
        formData.append(key, value);
      });
      formData.append("file", zipFile);

      for (let pair of formData.entries()) {
        console.log(pair[0] + ": " + pair[1]);
      }

      const uploadResponse = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*/*",
        },
      });
      console.log("Upload response:", uploadResponse);
      if (uploadResponse.status === 204 || uploadResponse.status === 200) {
        setFiles([]);
        setSelectedFiles([]);
        setFileSheetSelections({});
        setSelectedSheetnames([]);
        setFileSheets([]);
        console.log("File uploaded successfully to S3");
      }

      // Trigger Backend to convert files to parquets
      const resp = await API.postData("/process_zip_to_parquets", {
        "useremail": email,
        "jobname": customFilename,
        "rawzip_key": fields.key,
        "sheetnames": fileSheetSelections
      });

      console.log("resp")
      console.log(resp)
      console.log("resp")
      const uuid = resp.run_uuid
      set_setuuid(uuid)
      const user_email = email

      const chartName = customFilename
      
      console.log("uuid",uuid)
      console.log("user_email",user_email)

      const checkUploadStatus = async () => {
        try {
          console.log("Polling /get_classification_files...");
          const res = await API.postData("/get_classification_files",
             { "run_uuid":uuid, "useremail":user_email, "chartName":chartName });

          const statusCode = res.statusCode;     
          // const body = res.data; 

          if (statusCode === 200 && res.status === "READY") {
            get_userhistory()

            // console.log("Files Ready:", body.presigned_urls);
            console.log("Files status",res.status)
            // setClassificationResults(prev => ({
            //     ...prev,
            //     [customFilename]: {
            //       files: resss.data.presigned_urls || [],
            //       categories_count: resss.data.presigned_urls?.filter(f => f.filename.includes('categories')).length || 0,
            //       run_uuid: uuid,
            //       status: 'completed'
            //     }
            //   }));
          
          }
          if (statusCode === 202 && res.status === "INPROGRESS") {
            get_userhistory()
            console.log('Waiting for upload status to complete...',res.status);
            setTimeout(checkUploadStatus, 5000);
          }
          console.log("Unexpected response:", res);
        } catch (error) {
          const errorMessage = error.response?.data?.message || "Error while generating classification";
          console.error(errorMessage);

        }
      };
      
      checkUploadStatus();
      
      // intervalRef.current = setInterval(async () => {
      //   const { status } = await getStatus(email, customFilename);
        

      //   if (status.toLowerCase() === 'failed' || status.toLowerCase() === 'ready') {
      //     clearInterval(intervalRef.current);
      //     get_userhistory();
      //   }
      // }, 5000);

    } catch (error) {
      await API.postData("/updateMetaJson", {
        userEmail: email,
        status: "FAILED",
        fileName: customFilename,
      });
      setCustomFilename("");
      setFiles([]);
      setSelectedFiles([]);
      setFileSheetSelections({});
      setSelectedSheetnames([]);
      setFileSheets([]);
      console.error("Error creating ZIP file:", error);
      // alert("Failed to create ZIP file.");
    }
    finally {
      get_userhistory();
    }
  };

  const handlesnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackopen(false);
  };

  // Function to trigger file input click
  const handleButtonClick = () => {
    setOpenFilenameModal(true);

    // if (fileInputRef.current) {
    //   fileInputRef.current.value = "";
    //   fileInputRef.current.click();
    // }
  };

  const parseAndRenderSteps = (stepsText) => {
    console.log("in fucntion")
    const cleanedText = stepsText.replace(/^\n*Analyzed Steps -\s*\n*/i, '');

    const codeContent = cleanedText
      .replace(/^```python\n/, '')
      .replace(/\n```$/, '')
      .replace(/^\n/, '')
      .replace(/\n$/, '')
      .replace(/Input:\s*/g, '');

    const stepRegex = /Step \d+:/g;
    const stepMatches = [...codeContent.matchAll(stepRegex)];

    if (stepMatches.length === 0) {
      return <MarkdownFormat text={stepsText} />;
    }

    const steps = [];

    for (let i = 0; i < stepMatches.length; i++) {
      const currentMatch = stepMatches[i];
      const nextMatch = stepMatches[i + 1];

      const startIndex = currentMatch.index;
      const endIndex = nextMatch ? nextMatch.index : codeContent.length;

      const stepContent = codeContent.substring(startIndex, endIndex);

      const headerEndIndex = stepContent.indexOf(':') + 1;
      const stepHeader = stepContent.substring(0, headerEndIndex).trim();

      let remainingContent = stepContent.substring(headerEndIndex).trim();

      const outputIndex = remainingContent.indexOf('Output:');

      let stepCode, stepOutput;

      if (outputIndex !== -1) {
        stepCode = remainingContent.substring(0, outputIndex).trim();
        stepOutput = remainingContent.substring(outputIndex + 7).trim(); // 7 is the length of "Output:"
      } else {
        stepCode = remainingContent;
        stepOutput = "";
      }

      steps.push(
        <div key={i} className="step-item" style={{ marginBottom: '1.5rem' }}>
          <div className="step-header" style={{
            fontWeight: 'bold',
            marginBottom: '0.5rem',
            fontSize: '1rem'
          }}>
            {stepHeader}
          </div>
          {stepCode && (
            <div className="step-code">
              <MarkdownFormat text={`\`\`\`python\n${stepCode}\n\`\`\``} />
            </div>
          )}
          {stepOutput && (
            <div className="step-output" style={{
              marginTop: '0.5rem',
              backgroundColor: 'rgb(245 239 239)',
              padding: '8px',
              borderRadius: '6px',
              border: '1px solid #d4d4d4',
            overflow:"hidden"
            }}>
              <div style={{
                fontWeight: 'bold',
                marginBottom: '0.25rem',
                fontSize: '0.9rem',
                color: 'rgb(0, 0, 209)'
              }}>
                Output:
              </div>
              <div className="output-code">
                <MarkdownFormat text={`\`\`\`\n${stepOutput}\n\`\`\``} />
              </div>
            </div>
          )}
        </div>
      );
    }

    return <div className="steps-list">{steps}</div>;
  };

  const handleFileDialogClose = () => {
    if (!fileInputRef.current.files.length) {
      console.log("File dialog was closed without selecting a file.");
    }
  };

  const AINote = (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Box
        sx={{
          backgroundColor: "#d4d4d4",
          borderLeft: "6px solidrgb(47, 46, 40)",
          padding: "2px",
          width: "14rem",
          borderRadius: "5px",
          boxShadow: "5px 3px 5px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: "10px",
            fontStyle: "normal",
            color: "#555",
            fontWeight: 400,
            display: "flex",
            alignItems: "center",
          }}
        >
          <span
            style={{ fontSize: "14px", marginLeft: "6px", fontStyle: "normal" }}
          ></span>
          AI-generated responses may be inaccurate.
        </Typography>
      </Box>
    </Box>
  );

  const renderClassificationSection = (classification) => {
    if (!classification) return null;

    const imageFiles = classification.files?.filter(file => file.type === 'image') || [];
    const csvFiles = classification.files?.filter(file => file.type === 'csv') || [];

    const handleDownload = (url, filename) => {
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    return (
      <div className="classification-container mt-4" style={{
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '16px',
        marginTop: '16px',
        backgroundColor: '#f9f9f9'
      }}>
        <h4 className="classification-header" style={{
          fontWeight: 'bold',
          marginTop: '1rem',
          marginBottom: '0.5rem',
          color: '#2c3e50',
          borderBottom: '2px solid #3498db',
          paddingBottom: '8px'
        }}>
          Classification Results
        </h4>

        <div className="classification-info mb-3" style={{
          backgroundColor: '#e8f4fd',
          padding: '8px 12px',
          borderRadius: '4px',
          fontSize: '14px',
          marginBottom: '16px'
        }}>
          <p><strong>Categories found:</strong> {classification.categories_count || 'N/A'}</p>
          { <p><strong>Run ID:</strong> {classification.run_uuid || 'N/A'}</p> }
        </div>

        {csvFiles.length > 0 && (
          <div className="classification-downloads mb-4" style={{
            backgroundColor: '#f8f9fa',
            padding: '12px',
            borderRadius: '6px',
            border: '1px solid #dee2e6'
          }}>
            <h5 style={{ fontWeight: 'bold', color: '#34495e', marginBottom: '12px' }}>
              Download Classification Data
            </h5>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {csvFiles.map((file, index) => (
                <Button
                  key={index}
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => handleDownload(file.url, file.filename)}
                  startIcon={<InsertDriveFileIcon />}
                  style={{
                    backgroundColor: '#28a745',
                    color: 'white',
                    textTransform: 'none',
                    fontSize: '12px'
                  }}
                >
                  Download {file.filename.includes('categories') ? 'Categories' : 'Results'} CSV
                </Button>
              ))}
            </div>
          </div>
        )}
        {imageFiles.length > 0 && (
          <div className="classification-images" style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          }}>
            <h5 style={{ fontWeight: 'bold', color: '#34495e' }}>
              Classification Visualizations
            </h5>
            {imageFiles.map((file, index) => (
              <div key={index} className="classification-image mb-3">
                <div style={{
                  marginBottom: '8px',
                  fontWeight: '500',
                  color: '#555',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <span>
                    {file.filename.includes('plot') ? 'Category Distribution Plot' : 'Category Word Clouds'}
                  </span>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => window.open(file.url, '_blank')}
                    style={{
                      textTransform: 'none',
                      fontSize: '11px'
                    }}
                  >
                    Open in New Tab
                  </Button>
                </div>
                <img
                  src={file.url}
                  alt={`Classification ${file.filename.includes('plot') ? 'Distribution' : 'Word Cloud'}`}
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    marginBottom: '10px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    transition: 'transform 0.2s ease',
                    cursor: 'pointer'
                  }}
                  onError={(e) => {
                    console.error("Error loading image:", file.url);
                    e.target.style.display = 'none';
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
                  onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                  onClick={() => window.open(file.url, '_blank')}
                />
              </div>
            ))}
          </div>
        )}

        {(!classification.files || classification.files.length === 0) && (
          <div style={{
            padding: '16px',
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeaa7',
            borderRadius: '4px',
            color: '#856404'
          }}>
            <p>Classification completed but no files are available for download.</p>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="chat-container w-full w-[89%] h-[80%] flex items-center justify-center overflow-y-auto px-1 py-1 scroll resize-y">
      <div className="chat-wrapper w-full lg:w-4/5 flex flex-col h-full items-start justify-start max-w-[1200px]">
        <div style={{ marginTop: "5rem" }}></div>
        {user &&
          message?.map((msg, i) => (
            <div
              key={i}
              className="message-wrapper flex justify-start w-full my-2"
            >
              <span
                style={{ boxShadow: "rgb(43 43 43 / 13%) 4px 3px 4px 1px" }}
                className={
                  msg.isBot
                    ? "bot-message flex items-start justify-start gap-2 lg:gap-5 p-3 rounded-md max-w-[90%]"
                    : "user-message flex items-start justify-start gap-2 lg:gap-5 p-3 rounded-md max-w-[90%]"
                }
              >
                {msg.isBot ? (
                  <img
                    src={robotIcon}
                    style={{ width: "3rem", height: "3rem", flexShrink: 0 }}
                    alt=""
                  />
                ) : (
                  <Avatar
                    sx={{
                      bgcolor: "#d24a19",
                      width: "3rem",
                      height: "3rem",
                      flexShrink: 0
                    }}
                  >
                    {user ? user[0].toUpperCase() : "U"}
                  </Avatar>
                )}
                <div className="message-content overflow-hidden">
                  {msg.table && (
                    <div className="table-container w-full overflow-x-auto">
                      <CustomizedTables
                        columns={msg.table.columns}
                        data={msg.table.data}
                      />
                      <br />
                      <MarkdownFormat text={msg.tableanswer} />
                      {msg.classification && (<> <pre>{JSON.stringify(msg.classification, null, 2)}</pre>
                      renderClassificationSection(msg.classification)
                      </>)}
                      {msg.isBot && AINote}
                    </div>
                  )}
                  {msg.chart && (
                    <div className="chart-container mt-2 w-full overflow-x-auto">
                      <Plot
                        data={msg.chart.data}
                        layout={{
                          ...msg.chart.layout,
                          width: '100%',
                          height: 500,
                          autosize: true
                        }}

                        style={{ width: '100%', maxWidth: '800px' }}
                        useResizeHandler={true}
                      />
                      <br />
                      <br />
                      <MarkdownFormat text={msg.chartanswer} />
                      <br />
                      <div className="steps-container">
                        <h4 className="steps-header" style={{ fontWeight: 'bold', marginTop: '1rem', marginBottom: '0.5rem' }}>
                          Analyzed Steps
                        </h4>
                        {parseAndRenderSteps(msg.chartintr_steps)}
                      </div>
                      {msg.classification && renderClassificationSection(msg.classification)}
                      {msg.isBot && AINote}
                    </div>
                  )}
                  {msg.text && (
                    <div className="w-full overflow-x-auto">
                      <MarkdownFormat text={msg.text} />
                      <br />
                      {msg.textintr_steps && (
                        <div className="steps-container">
                          <h4 className="steps-header" style={{ fontWeight: 'bold', marginTop: '1rem', marginBottom: '0.5rem' }}>
                            Analyzed Steps
                          </h4>
                          {parseAndRenderSteps(msg.textintr_steps)}
                        </div>
                      )}
                      {msg.classification && renderClassificationSection(msg.classification)}
                      {msg.isBot && i !== 0 && i !== 1 && !msg.text.includes("Error:") && AINote}
                    </div>
                  )}
                  {msg.uploadbutton && (
                    <div className="upload-container w-full">
                      <input
                        type="file"
                        accept=".csv, .parquet, .xls, .xlsx"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                        onClick={(e) => (e.target.value = null)} // Reset file input to allow reselecting the same file
                        onBlur={handleFileDialogClose} // Detect when the file dialog closes without selection
                        multiple
                      />
                      {/* <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={handleButtonClick}
                    disabled={selectedFile}
                  >
                    Upload Files
                  </Button> */}
                      <StyledDialog open={openDialog} onClose={handleCloseDialog}>
                        <DialogTitle>ERROR</DialogTitle>
                        <DialogContent>
                          <DialogContentText>
                            <Typography
                              variant="body1"
                              style={{ fontWeight: "500", color: "red" }}
                            >
                              {dialogMessage}
                            </Typography>
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <CustomButton onClick={handleCloseDialog}>
                            Close
                          </CustomButton>
                        </DialogActions>
                      </StyledDialog>


                      {/* Dialog for To delete chat */}
                      <Dialog
                        open={showDeleteDialog}
                        onClose={() => {
                          setShowDeleteDialog(false);
                        }}
                      >
                        <DialogContent>
                          <Typography>
                            Are you sure you want to permanently delete this chat?
                          </Typography>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={() => {
                            setShortFileName("");
                            setShowDeleteDialog(false)
                          }} color="primary">
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              handleDeleteClick(shortFileName);
                              setShowDeleteDialog(false);
                              setShortFileName("");
                            }}
                            color="error"
                            variant="contained"
                          >
                            Delete
                          </Button>
                        </DialogActions>
                      </Dialog>

                      {/* New Dialog for entering custom filename */}
                      <Dialog
                        open={openFilenameModal}
                        onClose={() => {
                          setOpenFilenameModal(false);
                          setCustomFilename("");
                        }}
                        PaperProps={{
                          style: {
                            padding: "1rem",
                            height: "290px",
                            width: "600px", // Set custom width for the dialog
                            maxWidth: "90%", // Allow for flexibility on smaller screens
                            borderRadius: "10px", // Rounded corners for the dialog
                          },
                        }}
                      >
                        <DialogTitle sx={{ fontWeight: "bold" }}>
                          Please enter the Chat Name
                        </DialogTitle>
                        <DialogContent>
                          <TextField
                            autoFocus
                            margin="dense"
                            label="Chat Name"
                            fullWidth
                            variant="outlined"
                            value={customFilename}
                            onChange={(e) => setCustomFilename(e.target.value)}
                            error={inputFieldError}
                            // helperText={inputFieldHelperText ? inputFieldHelperText : <Alert sx={{ bgcolor: 'background.paper' }} severity="info">After confirming, select an Excel, CSV, or Parquet file to proceed.</Alert>}
                            helperText={inputFieldHelperText}
                          />
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => {
                              setOpenFilenameModal(false);
                              setCustomFilename("");
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={handleFilenameSubmit}
                            color="primary"
                            variant="contained"
                            disabled={!customFilename.length || inputFieldError}
                          >
                            Upload
                          </Button>
                        </DialogActions>
                      </Dialog>

                      {/* New Dialog for selecting files */}
                      <Dialog
                        open={openFileseModal}
                        onClose={() => {
                          setSelectedFiles([]);
                          setFileSheetSelections({});
                          setSelectedSheetnames([]);
                          setFiles([]);
                          setFileSheets([]);
                          setOpenFilesModal(false);
                          setCustomFilename("");
                        }}
                      >
                        <Box
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: { xs: "100%", sm: 1500 },  // Responsive width for smaller screens
                            bgcolor: "white",
                            borderRadius: 2,
                            boxShadow: 24,
                            p: 4,
                            height: {
                              xs: "auto",    // For smaller screens, allow auto height
                              sm: "auto",    // For medium screens, adjust to content height
                              md: 750,       // For larger screens, keep a fixed height (800px)
                            },
                            display: "flex",
                            flexDirection: "row",
                            overflowY: "auto", // Enable vertical scrolling for smaller screens
                          }}
                        >
                          <IconButton
                            aria-label="close"
                            // onClick={() => {
                            //   setSelectedFiles([]);
                            //   setFileSheetSelections({});
                            //   setSelectedSheetnames([]);
                            //   setFiles([]);
                            //   setFileSheets([]);
                            //   setOpenFilesModal(false);
                            //   setCustomFilename("");
                            // }}
                            onClick={() => setShowCloseConfirm(true)}
                            sx={{
                              position: 'absolute',
                              right: 8,
                              top: 8,
                              color: (theme) => theme.palette.grey[500],
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                          <Box
                            sx={{
                              flex: 6,
                              p: 2,
                            }}
                          >
                            <FormControl
                              margin="normal"
                              sx={{ width: "400px", marginRight: 2 }}
                            >
                              <InputLabel id="file-select-label">
                                Select Excel Files
                              </InputLabel>
                              <Select
                                labelId="file-select-label"
                                id="file-select"
                                label="Select Excel Files"
                                value={selectedFiles || ""}
                                onChange={handleUploadedFileChange}
                              >
                                {files
                                  .filter((file) => file.name.includes(".xlsx"))
                                  .map((file, index) => (
                                    <MenuItem key={index} value={file.name}>
                                      {file.name}
                                    </MenuItem>
                                  ))}
                              </Select>
                              <FormHelperText>Only excel files are allowed to select.</FormHelperText>

                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={isClassificationRequired}
                                    onChange={(e) => {
                                      setIsClassificationRequired(e.target.checked);
                                      console.log("hello it", e.target.checked);
                                    }}
                                    // onChange={(e) => setIsClassificationRequired(e.target.checked)}
                                    color="primary"
                                  />
                                }
                                label="Is classification required?"
                                sx={{ mt: 1 }}
                              />

                            </FormControl>

                            {!selectedFiles.includes(".csv") && (
                              <FormControl margin="normal" sx={{ mt: 2, width: 400 }}>
                                <InputLabel id="demo-multiple-checkbox-label">Select Sheets</InputLabel>
                                <Select
                                  labelId="demo-multiple-checkbox-label"
                                  id="demo-multiple-checkbox"
                                  multiple
                                  label="Select Sheets"
                                  value={selectedSheetnames}
                                  onChange={handleSelectedSheetChange}
                                  renderValue={(selected) => selected.join(", ")}
                                  MenuProps={MenuProps}
                                >
                                  {/* Select All / Unselect All Item */}
                                  <MenuItem
                                    value="all"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (selectedSheetnames.length === fileSheets.length) {
                                        handleSelectedSheetChange({ target: { value: [] } });
                                      } else {
                                        handleSelectedSheetChange({ target: { value: fileSheets } });
                                      }
                                    }}
                                  >
                                    <Checkbox
                                      checked={selectedSheetnames.length === fileSheets.length}
                                      indeterminate={
                                        selectedSheetnames.length > 0 &&
                                        selectedSheetnames.length < fileSheets.length
                                      }
                                    />
                                    <ListItemText
                                      primary={
                                        selectedSheetnames.length === fileSheets.length
                                          ? "Unselect All"
                                          : "Select All"
                                      }
                                    />
                                  </MenuItem>

                                  {/* Individual Sheet Items */}
                                  {fileSheets.map((name) => (
                                    <MenuItem key={name} value={name}>
                                      <Checkbox checked={selectedSheetnames.includes(name)} />
                                      <ListItemText primary={name} />
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            )}

                            {!files.some(file =>
                              /\.(xlsx|xls)$/i.test(file.name)
                            ) && <Box>
                                <Alert severity="warning" color="warning">
                                  No Excel files detected.
                                </Alert>
                              </Box>
                            }

                            <Box>
                              {/* Close Button */}
                              <Button
                                variant="contained"
                                color="primary"
                                sx={{ mt: 2, mr: 2 }}
                                onClick={handleFileDialog}
                              >
                                Close
                              </Button>
                              {/* Upload Button */}
                              <Button
                                variant="contained"
                                color="primary"
                                sx={{ mt: 2 }}
                                onClick={() => filterSheetsFromFiles(files)}
                                disabled={
                                  !isUploadDisabled(fileSheetSelections, files)
                                }
                              >
                                Confirm
                              </Button>
                            </Box>
                          </Box>

                          <Box
                            sx={{
                              flex: 4,
                              p: 2,
                            }}
                          >
                            <Box display="flex" flexWrap="wrap" gap={2}>
                              <Box
                                width="100%"
                                sx={{
                                  height: 670, // Fixed height for the whole box
                                  overflow: "hidden", // Hide any overflow from outer box
                                }}
                              >
                                <Card
                                  variant="outlined"
                                  sx={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <CardContent
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      flex: 1,
                                      overflow: "hidden",
                                    }}
                                  >
                                    {/* Scrollable list container */}
                                    <Box sx={{ flex: 1, overflowY: "auto", pr: 1 }}>
                                      <Box sx={{ mb: 3 }}>
                                        <Typography
                                          variant="h6"
                                          fontWeight="bold"
                                          gutterBottom
                                        >
                                          Selected CSV and Parquet Files
                                        </Typography>

                                        {files.filter(
                                          (file) =>
                                            file.name
                                              .toLowerCase()
                                              .endsWith(".csv") ||
                                            file.name
                                              .toLowerCase()
                                              .endsWith(".parquet")
                                        ).length === 0 && (
                                            <Typography variant="h6" gutterBottom>
                                              No CSV and Parquet files selected yet
                                            </Typography>
                                          )}

                                        {files
                                          .filter((file) => {
                                            const ext = file.name.toLowerCase();
                                            return (
                                              ext.endsWith(".csv") ||
                                              ext.endsWith(".parquet")
                                            );
                                          })
                                          .map((filteredFile, index) => (
                                            <ListItem
                                              key={`${filteredFile.name}-${index}`}
                                              disablePadding
                                            >
                                              <ListItemIcon>
                                                <Checkbox
                                                  checked
                                                  disabled
                                                  sx={{
                                                    color: "green",
                                                    "&.Mui-checked": {
                                                      color: "green",
                                                    },
                                                    "&.Mui-disabled": {
                                                      color: "green",
                                                    },
                                                    "&.Mui-disabled.Mui-checked": {
                                                      color: "green",
                                                    },
                                                  }}
                                                />
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={filteredFile.name}
                                              />
                                            </ListItem>
                                          ))}
                                      </Box>
                                      <Divider />

                                      <Typography
                                        sx={{ marginY: 2 }}
                                        variant="h6"
                                        gutterBottom
                                        fontWeight="bold"
                                      >
                                        Selected sheets per file
                                      </Typography>
                                      {Object.entries(fileSheetSelections).length >
                                        0 ? (
                                        Object.entries(fileSheetSelections).map(
                                          ([fileName, sheets]) => (
                                            <Box key={fileName} mb={2}>
                                              <Typography
                                                variant="subtitle1"
                                                fontWeight="bold"
                                              >
                                                {fileName}
                                              </Typography>

                                              {sheets.length > 0 ? (
                                                <List dense>
                                                  {sheets.map((sheet, idx) => (
                                                    <ListItem
                                                      key={`${fileName}-${idx}`}
                                                      disablePadding
                                                    >
                                                      <ListItemIcon>
                                                        <Checkbox
                                                          checked
                                                          disabled
                                                          sx={{
                                                            color: "green",
                                                            "&.Mui-checked": {
                                                              color: "green",
                                                            },
                                                            "&.Mui-disabled": {
                                                              color: "green",
                                                            },
                                                            "&.Mui-disabled.Mui-checked":
                                                              { color: "green" },
                                                          }}
                                                        />
                                                      </ListItemIcon>
                                                      <ListItemText
                                                        primary={sheet}
                                                      />
                                                    </ListItem>
                                                  ))}
                                                </List>
                                              ) : (
                                                <Typography
                                                  variant="body2"
                                                  color="text.secondary"
                                                >
                                                  No sheets selected.
                                                </Typography>
                                              )}
                                            </Box>
                                          )
                                        )
                                      ) : (
                                        <Typography
                                          variant="body2"
                                          color="text.secondary"
                                        >
                                          No sheets selected.
                                        </Typography>
                                      )}
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Dialog>

                      <Dialog
                        open={showCloseConfirm}
                        onClose={() => setShowCloseConfirm(false)}
                      >
                        {/* <DialogTitle>Confirm Close</DialogTitle> */}
                        <DialogContent>
                          <Typography>
                            Are you sure you want to close?
                          </Typography>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={() => setShowCloseConfirm(false)} color="primary">
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              // Reset everything and close both modals
                              setSelectedFiles([]);
                              setFileSheetSelections({});
                              setSelectedSheetnames([]);
                              setFiles([]);
                              setFileSheets([]);
                              setOpenFilesModal(false);
                              setCustomFilename("");
                              setShowCloseConfirm(false); // close confirmation dialog too
                            }}
                            color="error"
                            variant="contained"
                          >
                            Close
                          </Button>
                        </DialogActions>
                      </Dialog>


                    </div>
                  )}
                </div>
              </span>
            </div>
          ))}
        <div ref={msgEnd} />
      </div>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={modalStyle}>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <InsertDriveFileIcon sx={{ mr: 1, color: "#1976d2" }} />
            Please Select Sheet Name
          </Typography>

          <Select
            value={sheetName}
            onChange={handleSheetChange}
            fullWidth
            sx={{ mt: 2 }}
          >
            {availableSheets.map((sheet, index) => (
              <MenuItem key={index} value={sheet}>
                {sheet}
              </MenuItem>
            ))}
          </Select>

          <Button
            // onClick={handleSubmit}
            variant="contained"
            sx={{
              mt: 3,
              bgcolor: "#1976d2",
              "&:hover": { bgcolor: "#1565c0" },
            }}
          >
            Submit
          </Button>
        </Box>
      </Modal>
      <Snackbar
        style={{ marginTop: "14rem" }}
        open={snackopen}
        autoHideDuration={2000}
        onClose={handlesnackClose}
        message="Just a moment! We're Extracting the sheet names from Excel file..."
        anchorOrigin={{
          vertical: "top", // Adjust vertical positioning
          horizontal: "center", // Adjust horizontal positioning
        }}
      />

    </div>

  );


}

export default Chat;
